import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { listsService } from '@/modules/chatting/service/lists'
import { handleError } from '@/utils/error'

export const useProgress = (listId?: number) => {
  const creatorId = useUnit($creatorId)

  const { data } = useQuery(
    ['openChatsListCreationProgress', listId],
    () => listsService.getListCreationProgress(creatorId!, listId!),
    {
      enabled: !!listId && !!creatorId,
      refetchInterval: (data) => !data?.completed && 2000,
      onError: (error) =>
        handleError(error, 'Failed to get list creation progress'),
    },
  )

  let progress = 0

  if (data) {
    progress = data.completed
      ? 100
      : data.total
        ? Math.round(((data.total - data.remaining) * 100) / data.total)
        : 0
  }

  return {
    progress,
    completed: data?.completed ?? false,
    success: data?.success,
    failure: data?.failure,
    total: data?.total,
  }
}
